<p-tabMenu
  class="tab-menu"
  [model]="tabs"
  [activeItem]="activeTab"
  (click)="select($event)">
</p-tabMenu>